console.log('KLAVIYO SCRIPT LOADED');

const KLAVIYO_COMPANY_ID = 'YzFPAd';

function klaviyoUuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Direct call to Klaviyo's public client Events API (safe client-side: uses the
// public company_id, not a private key). Added because the onsite embed's own
// klaviyo.track() call was not producing any outbound request in this account's
// current bundle — calling the REST endpoint ourselves is verifiable independent
// of that embed's internal behavior. Skips guests: this endpoint requires a
// profile identifier (email/phone/id), and we only have email for logged-in
// customers via window.__klCustomerEmail (set in theme.liquid).
async function sendKlaviyoEventViaClientAPI(metricName, properties, value) {
  const email = window.__klCustomerEmail;
  if (!email) return;

  try {
    const res = await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', revision: '2026-07-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties,
            value,
            unique_id: klaviyoUuid(),
            metric: { data: { type: 'metric', attributes: { name: metricName } } },
            profile: { data: { type: 'profile', attributes: { email } } }
          }
        }
      })
    });
    if (!res.ok) {
      console.error('Klaviyo client Events API rejected the request:', res.status, await res.text());
    }
  } catch (err) {
    console.error('Klaviyo client Events API call failed:', err);
  }
}

// Called directly by each add-to-cart success handler (main.js, custom-mw.js,
// variant-picker.liquid) with the parsed /cart/add.js response. Not wired via a
// window.fetch override — Shopify's own standard-actions.js overwrites window.fetch
// after page load and silently discarded that approach.
async function sendKlaviyoAddToCartEvent(addToCartResponse) {
  if (!window.klaviyo || !addToCartResponse) return;

  try {
    const items = addToCartResponse.items || [addToCartResponse];
    const validItems = items.filter((item) => item && item.product_id);
    if (!validItems.length) return;

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const totalSavings = cart.items.reduce((sum, i) => sum + (i.total_discount || 0), 0) / 100;
    const originalCartTotal = cart.items.reduce((sum, i) => sum + (i.original_line_price || 0), 0) / 100;

    const cartItemsPayload = cart.items.map((i) => ({
      ProductID: i.product_id,
      VariantID: i.variant_id,
      ProductName: i.product_title,
      VariantTitle: i.variant_title,
      Price: i.price / 100,
      Quantity: i.quantity,
      ImageURL: i.image,
      URL: window.location.origin + i.url
    }));

    validItems.forEach((item) => {
      const payload = {
        AddedItem: {
          ProductID: item.product_id,
          VariantID: item.variant_id,
          ProductName: item.product_title,
          VariantTitle: item.variant_title,
          SKU: item.sku,
          Price: item.price / 100,
          Quantity: item.quantity,
          ImageURL: item.image,
          URL: window.location.origin + item.url
        },
        CartItems: cartItemsPayload,
        CartTotal: cart.total_price / 100,
        CartTotalBeforeDiscount: originalCartTotal,
        TotalSavings: totalSavings,
        ItemCount: cart.item_count
      };

      console.log('Klaviyo Payload', payload);
      klaviyo.track('Added to Cart', payload);
      sendKlaviyoEventViaClientAPI('Added to Cart - Abandoned', payload, payload.AddedItem.Price * payload.AddedItem.Quantity);
    });
  } catch (err) {
    console.error('Klaviyo Added to Cart tracking failed:', err);
  }
}

window.klaviyoTrackAddToCart = sendKlaviyoAddToCartEvent;
